/**
 * BuyNowButton，直接结算，点击元素本身触发
 * 
 * 注：要实现 variant id 和 quantity 动态变化，请在组件外部的逻辑中控制属性变化。
 *   例如要立即购买 10 件商品，使用 $("buy-now-button").attr("data-quantity", 10) 变更数量。
 * 
 * Attributes:
 * @param {String} data-variant-id 产品变体 ID
 * @param {String} data-quantity 购买数量，可选，默认为1
 * 
 * @example 
 * ```html
 * <script src="{{ 'component-buy-button.js' | asset_url }}" defer="defer"></script>
 * <buy-now-button data-variant-id="{{ product.first_available_variant.id }}" data-quantity="1" class="button round">
 *   Buy Now
 *   {%- render 'loading-spinner' -%}
 * </buy-now-button>
 * ```
 */
if (!customElements.get('buy-now-button')) {
    class BuyNowButton extends HTMLElement {
      // 标记
      _marks = {
        loading: "loading"
      };
  
      _shopify_features_script = document.querySelector("script[id='shopify-features']");
      _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
      _checkout_headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
      };
  
      get _variantId() { return this.getAttribute("data-variant-id") }
      get _quantity() { return this.getAttribute("data-quantity") ?? 1 }
  
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.elements = {
          loadingSpinner: this.querySelector(".loading__spinner"),
        };
        this.addEventListener('click', (e) => {
          this.startLoading();
          this.checkout().finally(() => {
            this.finishLoading();
          });
        });
      }
  
      /**
       * 直接结算
       */
      async checkout() {
        const variantIds = this._variantId.split(',');
        let lineItems = variantIds.map(variantId => ({
          "variant_id": variantId,
          "quantity": this._quantity
        }));
        let checkout_json = {
          "checkout": {
            "line_items": lineItems,
            "secret": true,
            "wallet_name": "Checkout",
            "is_upstream_button": false,
            "page_type": "product",
            "has_selling_plans": false,
            "presentment_currency": window.shop_currency,
            "country": window.shop_locale_upcase
          }
        }

        // let checkout_json = {
        //   "checkout": {
        //     "line_items": [
        //       {
        //         "variant_id": this._variantId,
        //         "quantity": this._quantity
        //       }
        //     ],
        //     "secret": true,
        //     "wallet_name": "Checkout",
        //     "is_upstream_button": false,
        //     "page_type": "product",
        //     "has_selling_plans": false,
        //     "presentment_currency": window.shop_currency,
        //     "country": window.shop_locale_upcase
        //   }
        // }
        
        let data = JSON.stringify(checkout_json);
        return fetch("/wallets/checkouts.json",
          {
            method: 'POST',
            headers: this._checkout_headers,
            body: data
          }
        ).then(function (response) {
          if (response.ok) {
            return response.text();
          }
        }).then(function (strj) {
          let checkout_json = JSON.parse(strj);
          location.href = checkout_json.checkout.web_url;
        }).catch(function (err) {
          console.error(err);
        });
      }
  
      startLoading() {
        this.setAttribute("aria-disabled", true);
        this.classList.add(this._marks.loading);
        this.elements.loadingSpinner?.classList.remove("hidden");
      }
  
      finishLoading() {
        this.removeAttribute("aria-disabled");
        this.classList.remove(this._marks.loading);
        this.elements.loadingSpinner?.classList.add("hidden");
      }
    }
  
    customElements.define('buy-now-button', BuyNowButton);
  }